/**
 * Hello World example component
 */

module.exports = function (app) {
  app.registerComponent('custom-dropdown', '.js-custom-dropdown', function (sb, el) {

    const select = el.querySelector('select');
    const dropdownDisplay = el.querySelector('.dropdown-display');
    const selectedText = el.querySelector('.dropdown-selected');
    const dropdownOptions = el.querySelector('.dropdown-options');


    dropdownDisplay.addEventListener('click', function() {
      dropdownDisplay.classList.toggle('open');
    });



    const onOptionClick = (ev) => {
      const option = ev.currentTarget;
      const value = option.getAttribute('data-value');

      // select.value = value;
      select.value = value;
      setActiveOption(value)
      selectedText.textContent = option.querySelector('strong').textContent;

      // selectedText.textContent = option.querySelector('strong').textContent;
      // dropdownDisplay.classList.remove('open');
    }

    const setInititalValue = () => {
      // let rawValue = select.value;
      let label = '';
      let value = '';

      console.log(select.value)
      if (select.value === '') {
        label = select.options[0].textContent;
        value = select.options[0].value;
      } else {
        label = select.options[select.selectedIndex].textContent.split('|')[0];
        value = select.options[select.selectedIndex].value;
      }

      // let value = 
      // let label = rawValue.split('|')[0];
      // let splitted = rawValue.split('|');
      // let value = splitted[0];

      selectedText.textContent = label;


      setActiveOption(value)
      // console.log(value)

    }
    const setActiveOption = (value) => {
      console.log(select.value)
      customOptions.forEach(option => {
        option.classList.remove('active');
        if (option.getAttribute('data-value') === value) {
          option.classList.add('active');
        }
      });
    }

    // event listeners for the options
    const customOptions = document.querySelectorAll('.dropdown-option');
    customOptions.forEach(option => {
        option.addEventListener('click', onOptionClick)
    });


    /* INIT ------------------------------------------- */
    return {
      init: function () {
        console.log('custom-dropdown init')
        // console.log(select.value)
        setInititalValue()


      },
      destroy: function () {
        customOptions.forEach(option => {
          option.removeEventListener('click', onOptionClick)
      });
  
      }
    }
  })
}



// WEBPACK FOOTER //
// ./assets/js/components/custom-dropdown.js